module.exports = ["【系统消息】会话已被系统终结，感谢您的来访，祝您愉快，再见！","[System Message] The session has been terminated by the system, thank you for your visit, have a nice day!","客服已结束会话","Customer service has closed the conversation."]


//////////////////
// WEBPACK FOOTER
// ./src/config/logoutMessage.json
// module id = CPHO
// module chunks = 2